/** @license MIT License (c) copyright 2016 original author or authors */

export * from './array'
export * from './function'
